import React from 'react'
import jwt_decode from 'jwt-decode'
import PropTypes from 'prop-types'
import styled, { useTheme } from 'styled-components'
import { Search } from '@dsny/dsny-component-library/icons'
import { DownloadButton, ChatButton } from 'components'
import { useDesktopMediaQuery, useMobileMediaQuery } from 'utils/hooks/useMediaQueries'
import InviteConnection from '../../containers/InviteConnection/InviteConnection'
import UserDropdown from '../Dropdowns/UserDropdown'

const InviteConnectionWrapper = styled.div``

export default function GlobalActionMenu({
  style = {},
  inNetwork,
  onMobileSearchClick,
  showMobileSearchIcon = true
}) {
  const isDesktop = useDesktopMediaQuery()
  const isDownloadHidden = useMobileMediaQuery()
  const isCompact = !isDesktop
  const theme = useTheme()
  const token = localStorage.getItem('accessToken')
  const currentUser = jwt_decode(token)
  const verifiedUser = currentUser.verified

  return (
    <div
      className="flex flex-row items-center"
      style={{ gap: '16px', ...style }}>
      {verifiedUser && (
        <InviteConnectionWrapper>
          <InviteConnection inNetwork={inNetwork} />
        </InviteConnectionWrapper>
      )}
      {isCompact && showMobileSearchIcon && (
        <Search
          width={18}
          height={18}
          color={theme.colors.neutralW90}
          onClick={() => onMobileSearchClick && onMobileSearchClick()} />
      )}
      <ChatButton
        style={{
          width: 18
        }} />
      {!isDownloadHidden && <DownloadButton />}
      <UserDropdown />
    </div>
  )
}

GlobalActionMenu.propTypes = {
  style: PropTypes.object,
  inNetwork: PropTypes.bool,
  onMobileSearchClick: PropTypes.func,
  showMobileSearchIcon: PropTypes.bool
}
